export default {
  outList: [
    {
      light_point_1: [
        {
          title: '几何韵律前脸造型',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: '徽派建筑“檐平脊正” 的美学范式'
        },
      ],
      light_point_3: [
        {
          title: '磐石车身“硬”核守护',
          type: 'image',
          video: '',
          image: 'lightPoint/3/1.jpg',
          text: '车身85%高强度钢，21%热成型钢',
          text2: '双防撞梁+6吸能盒，6倍顶压'
        },
      ]
    }
  ],
  innerList: [
    {
      light_point_1: [
        {
          title: '15.6吋2.5K高清大屏',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: '64倍色彩品质提升、90%超高屏占比'
        },
      ],
      light_point_2: [
        {
          title: '女王副驾',
          type: 'image',
          video: '',
          image: 'lightPoint/2/5.jpg',
          text: '豪华方盒同款侧开尾门',
          text2: '通风加热、3点Spa级按摩、电动腿托、副驾老板键'
        },
      ],
      light_point_3: [

        {
          title: '5+2座灵活布局',
          type: 'image',
          video: '',
          image: 'lightPoint/2/2.jpg',
          text: ''
        },
        {
          title: '12种可变组合空间',
          type: 'image',
          video: '',
          image: 'lightPoint/2/3.jpg',
          text: ''
        },
        {
          title: '二三排一键放倒，秒变2.1m大床房',
          type: 'image',
          video: '',
          image: 'lightPoint/2/4.jpg',
          text: ''
        },
      ]
    }
  ],
  tab1: [
    {
      title: '高通骁龙8255芯片',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: '5nm制程工艺 | 8核CPU | 算力达230K，算力提升119%， 开机速度提升约26%',
      text2: ''
    },
    {
      title: '猎鹰500驾驶辅助',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: '38项智能驾驶辅助功能、高速NOA、20条150KM VIP私人定制城市领航',
    },
    {
      title: '猎鹰500驾驶辅助',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '300+智慧泊车场景'
    },
    {
      title: '15.6吋2.5K高清大屏',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: '64倍色彩品质提升、90%超高屏占比'
    },
    {
      title: '伯牙之音环绕音响系统',
      type: 'image',
      video: '',
      image: 'lightPoint/1/5.jpg',
      text: '14个声学单元（12+2主驾头枕音响）、400w功率、7.1全景声布局、近1G AI算力'
    },
  ],
  tab2: [
    {
      title: '同级领先宽体空间',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '946mm同级领先二排空间,同级领先头部空间（1028/1006）',
      text2: '最大2065L后备箱空间 ,38处储物空间',
    },
    {
      title: '5+2座灵活布局',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: ''
    },
    {
      title: '12种可变组合空间',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: ''
    },
    {
      title: '二三排一键放倒，秒变2.1m大床房',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: ''
    },
    {
      title: '女王副驾',
      type: 'image',
      video: '',
      image: 'lightPoint/2/5.jpg',
      text: '豪华方盒同款侧开尾门',
      text2: '通风加热、3点Spa级按摩、电动腿托、副驾老板键'
    },
    {
      title: '3D Mesh仪表台+Tom饰板',
      type: 'image',
      video: '',
      image: 'lightPoint/2/6.jpg',
      text: '源于每个细节的用心，更考究的质感演绎'
    },
  ],
  tab3: [
    {
      title: '磐石车身“硬”核守护',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '车身85%高强度钢，21%热成型钢',
      text2: '双防撞梁+6吸能盒，6倍顶压'
    },
    {
      title: '同级领先7气囊',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '贯穿式侧气帘',
      text2: '同级独有远端气囊，6s保压',
    },
  ],
  tab4: [
    {
      title: '鲲鹏2.0TGDI发动机+第二代8AT',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: '390N·m峰值扭矩',
      text2: '“中国心”十佳发动机',
    },
  ]
}
